import { useTranslation } from 'react-i18next';
import { createCheckboxField } from './createCheckboxField';

/**
 * `BathroomInformations` is a hook that manages the structure and properties of bathroom information fields.
 * It returns an array of objects where each object defines a checkbox field with associated properties such as `name`, `input`, and `valuePropName`.
 * The `input` property contains a Checkbox component with localized labels retrieved using `useTranslation` hook.
 *
 * @hook
 * @returns {Object} - An object containing an array of field configurations for the bathroom information section in the form.
 */
const BathroomInformations = () => {
  const { t } = useTranslation();

  const bathroomInformationsFields = [
    createCheckboxField('bathroom', 'independant_bathroom', t),
    createCheckboxField('bathroom', 'shower', t),
    createCheckboxField('bathroom', 'bathroom_towel', t)
  ];

  return {
    bathroomInformationsFields
  };
};

export default BathroomInformations;
